import { Box, BoxProps, Text } from "@chakra-ui/react";

type LabeledTextProps = BoxProps & {
    label: string;
    text: string;
}

const LabeledText = ({
    label,
    text,
    ...rest
}: LabeledTextProps) => {
    return (
        <Box {...rest}>
            <Text fontWeight="500" fontSize="sm">{label}</Text>
            <Text>{text}</Text>
        </Box>
    )
}
export default LabeledText